import React from 'react';
import { Button, Text } from '@spothero/ui';
import useTouch from 'hooks/use-touch';
import { useMobileWebRelevanceVariation } from 'hooks/use-mobile-web-relevance-variation';
const DynamicSpotListItemButton = ({ isAdmin, available, isRebookingReservation, isHovered, onClick, isMonthly = false, ...props }) => {
    const { isVariation1, isVariation2 } = useMobileWebRelevanceVariation();
    const isUnavailable = isAdmin && !available;
    const dynamicCTA = isUnavailable
        ? 'Unavailable'
        : isRebookingReservation
            ? 'Rebook It'
            : isMonthly
                ? 'View Details'
                : 'Book Now';
    const isBookNowVariant = dynamicCTA === 'Book Now' && (isVariation1 || isVariation2);
    // The hover state is applied when:
    // 1. The button is hovered
    // 2. The corresponding spot pin on the map is hovered
    const dynamicButtonStyleProps = isBookNowVariant
        ? {
            marginLeft: 4,
            // Important is used due to the specificity of backgroundColor
            // https://github.com/spothero/consumer-web/blob/da1ae6ca0e37fc1134732078172a7148028ecbbd/src/sass/search/spot-list/_SpotListSearchControlsCondensed.scss#L103
            backgroundColor: 'white !important',
            borderColor: isHovered ? 'primary.600' : 'gray.medium',
            color: isHovered ? 'primary.600' : 'primary.default',
            _hover: {
                backgroundColor: isUnavailable ? 'gray.medium' : 'white',
                borderColor: isUnavailable ? 'gray.medium' : 'primary.600',
                color: isUnavailable ? 'gray.dark' : 'primary.600',
            },
        }
        : {
            marginLeft: 4,
            backgroundColor: isHovered ? 'primary.600' : 'primary.default',
            borderColor: isHovered ? 'primary.600' : 'primary.default',
            _hover: {
                backgroundColor: isUnavailable
                    ? 'gray.medium'
                    : 'primary.600',
                borderColor: isUnavailable ? 'gray.medium' : 'primary.600',
                color: isUnavailable ? 'gray.dark' : 'white',
            },
        };
    const monthlyDynamicButtonStyleProps = {
        color: isHovered && !isUnavailable
            ? 'primary.600'
            : isUnavailable
                ? 'gray.dark'
                : 'primary.default',
        _hover: {
            color: !isUnavailable ? 'primary.600' : 'gray.dark',
        },
    };
    const adminBorderButtonStyleProps = {
        borderColor: 'warning',
        borderWidth: '4px',
        borderStyle: 'solid',
        borderRadius: '4px',
        ...(isMonthly && { padding: 1 }),
        _hover: {
            borderColor: 'warning',
            ...(!isMonthly && { backgroundColor: 'primary.600' }),
        },
    };
    const handleClick = (e) => {
        // We stop propagation here to prevent the parent element from being clicked.
        e.stopPropagation();
        if (onClick) {
            onClick(e);
        }
    };
    const { onTouchStart, onTouchEnd } = useTouch(handleClick);
    return (<Button data-testid="SpotCardDynamicCTAButton" variant={isMonthly && !isUnavailable ? 'tertiary' : 'primary'} onClick={handleClick} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} isDisabled={isUnavailable} {...(isMonthly
        ? { ...monthlyDynamicButtonStyleProps }
        : { ...dynamicButtonStyleProps })} {...(isAdmin &&
        isRebookingReservation && { ...adminBorderButtonStyleProps })} {...props}>
            {dynamicCTA}
            {isUnavailable && (<Text as="sup" variant="caption" lineHeight={0}>
                    *
                </Text>)}
        </Button>);
};
export default DynamicSpotListItemButton;
